var _rect, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    fill: "#762B00",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.7034L12.038 25.6654C11.815 25.8885 11.5311 26 11.1863 26C10.8416 26 10.5577 25.8885 10.3346 25.6654C10.1115 25.4423 10 25.1584 10 24.8137C10 24.4689 10.1115 24.185 10.3346 23.962L16.2966 18L10.3346 12.038C10.1115 11.815 10 11.5311 10 11.1863C10 10.8416 10.1115 10.5577 10.3346 10.3346C10.5577 10.1115 10.8416 10 11.1863 10C11.5311 10 11.815 10.1115 12.038 10.3346L18 16.2966L23.962 10.3346C24.185 10.1115 24.4689 10 24.8137 10C25.1584 10 25.4423 10.1115 25.6654 10.3346C25.8885 10.5577 26 10.8416 26 11.1863C26 11.5311 25.8885 11.815 25.6654 12.038L19.7034 18L25.6654 23.962C25.8885 24.185 26 24.4689 26 24.8137C26 25.1584 25.8885 25.4423 25.6654 25.6654C25.4423 25.8885 25.1584 26 24.8137 26C24.4689 26 24.185 25.8885 23.962 25.6654L18 19.7034Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileClose);
export default __webpack_public_path__ + "static/media/mobile_close.1102d912a1fec7b9b9d25966e6d203f2.svg";
export { ForwardRef as ReactComponent };